import { useCallback, useRef, useState } from 'react'

import { useGranularEffect } from 'granular-hooks'
import { filter, get, isEmpty, noop, reject } from 'lodash'

import api from 'common/api'
import { useIsAuthed } from 'components/AuthShield'

export const search = () => {
  return api.get('/api/colleges/for-you/similar').catch(noop)
}

export const useRandomYouMayAlsoLike = (open, following, count) => {
  const [colleges, setColleges] = useState([])
  const [startIndex, setStartIndex] = useState(0)
  const openRef = useRef()
  const lastCountRef = useRef(0)
  const isAuthed = useIsAuthed()

  // Fetch colleges and reset startIndexing page
  const getColleges = useCallback(() => {
    if (isAuthed) {
      search().then((response) => {
        const inst = get(response, 'Institutions')
        const withoutFollowing = filter(inst, function ({ Scid }) {
          return !following[Scid]
        })
        setColleges(withoutFollowing)
        setStartIndex(0)
      })
    }
  }, [following, isAuthed])

  // Change page each time open changes
  useGranularEffect(
    () => {
      if (open && openRef.current !== open) {
        const next = startIndex + 3
        if (colleges.length >= next + 2) {
          setStartIndex(next)
        } else {
          setStartIndex(0)
        }
      }
      openRef.current = open
    },
    [open],
    [colleges, startIndex],
  )

  // Fectch new list of colleges when following count changes
  useGranularEffect(
    () => {
      if (!open && count !== lastCountRef.current) {
        getColleges()
        lastCountRef.current = count
      }
    },
    [count],
    [open, getColleges],
  )

  return reject([colleges[startIndex], colleges[startIndex + 1], colleges[startIndex + 2]], isEmpty)
}
